import { gql } from "@apollo/client";

// Query to get clinic info by public ID
export const GET_CLINIC_BY_PUBLIC_ID = gql`
  query GetClinicByPublicId($publicId: String!) {
    clinicByPublicId(publicId: $publicId) {
      publicId
      name
    }
  }
`;

// Mutation to submit patient education form
export const SUBMIT_PATIENT_EDUCATION_FORM = gql`
  mutation SubmitPatientEducationForm($input: SubmitPatientEducationDTO!) {
    submitPatientEducationForm(input: $input) {
      success
      reportId
      message
    }
  }
`;

// Mutation to track patient education Heap event
export const TRACK_PATIENT_EDUCATION_HEAP_EVENT = gql`
  mutation TrackPatientEducationHeapEvent(
    $input: TrackPatientEducationHeapEventDTO!
  ) {
    trackPatientEducationHeapEvent(input: $input)
  }
`;

// TypeScript types for GraphQL responses
export interface PublicClinic {
  publicId: string;
  name: string;
}

export interface GetClinicByPublicIdData {
  clinicByPublicId: PublicClinic | null;
}

export interface GetClinicByPublicIdVariables {
  publicId: string;
}

export enum BiologicalSex {
  MALE = "MALE",
  FEMALE = "FEMALE",
  OTHER = "OTHER",
}

export enum InterestResponse {
  YES = "YES",
  NO = "NO",
  MORE_INFO = "MORE_INFO",
}

export interface SubmitPatientEducationInput {
  clinicPublicId: string;
  firstName: string;
  lastName: string;
  biologicalSex: BiologicalSex | null;
  dateOfBirth: string; // ISO date string
  panoramaInterest: InterestResponse | null;
  horizonInterest: InterestResponse | null;
  panoramaVideoPercent?: number;
  horizonVideoPercent?: number;
  language?: string;
}

export interface SubmitPatientEducationVariables {
  input: SubmitPatientEducationInput;
}

export interface PatientEducationSubmissionResponse {
  success: boolean;
  reportId: number;
  message: string;
}

export interface SubmitPatientEducationData {
  submitPatientEducationForm: PatientEducationSubmissionResponse;
}

export interface TrackPatientEducationHeapEventInput {
  clinicPublicId: string;
  eventName: string;
  eventPropertiesJson?: string;
}

export interface TrackPatientEducationHeapEventVariables {
  input: TrackPatientEducationHeapEventInput;
}

export interface TrackPatientEducationHeapEventData {
  trackPatientEducationHeapEvent: boolean;
}
